import { createSlice } from "@reduxjs/toolkit";

const contactPersonSlice = createSlice({
  name: "contactPerson",
  initialState: [],
  reducers: {
    setContactPersons: (state, action) => {
      return action.payload;
    },
    addContactPerson: (state, action) => {
      state.push(action.payload);
    },
    updateContactPerson: (state, action) => {
      const index = state.findIndex(cp => cp.id === action.payload.id);
      if (index !== -1) {
        state[index] = action.payload;
      }
    },
    removeContactPerson: (state, action) => {
      return state.filter(cp => cp.id !== action.payload);
    },
  },
});

export const { setContactPersons, addContactPerson, updateContactPerson, removeContactPerson } =
  contactPersonSlice.actions;

export default contactPersonSlice.reducer;
